import React from "react";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";

export interface SearchableSelectOption {
  value: string | number;
  label: string;
}

interface SearchableMultiSelectProps {
  inputId: string;
  label: string;
  options: SearchableSelectOption[];
  value: Array<string | number>;
  onChange: (value: Array<string | number>) => void;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  selectionLimit?: number;
  showClear?: boolean;
}

export default function SearchableMultiSelect({
  inputId,
  label,
  options,
  value,
  onChange,
  disabled = false,
  required = false,
  placeholder = "Select",
  selectionLimit,
  showClear = false,
}: SearchableMultiSelectProps) {
  return (
    <label htmlFor={inputId} className="block text-sm font-medium">
      {label}
      <MultiSelect
        inputId={inputId}
        value={value}
        options={options}
        optionLabel="label"
        optionValue="value"
        filter
        filterBy="label"
        filterPlaceholder={`Search ${label.toLowerCase()}`}
        display="comma"
        maxSelectedLabels={1}
        selectionLimit={selectionLimit}
        showClear={showClear}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        className="mt-1 w-full text-sm"
        panelClassName="text-sm"
        onChange={(event: MultiSelectChangeEvent) => onChange(event.value ?? [])}
      />
    </label>
  );
}
